import type { SVGProps } from 'react';

const FileIcon = (props: SVGProps<SVGSVGElement>) => (
   <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
   >
      <path
         d="M3 3V29C3 30.6569 4.34315 32 6 32H26C27.6569 32 29 30.6569 29 29V12L17 0H6C4.34315 0 3 1.34315 3 3Z"
         fill="#E3E8ED"
      />
      <path d="M17 0L29 12H20C18.3431 12 17 10.6569 17 9V0Z" fill="#AFBBC4" />
      <rect x="7" y="18" width="18" height="8" rx="2" fill="#D2DADF" />
   </svg>
);

export default FileIcon;
